import React from "react";

export const useStopRecordingAndUpload = (
  mediaRecorderRef,
  timerRef,
  setIsRecording,
  setIsUploading,
  chunksRef,
  loan_details,
  video_pdn_id,
  req_user_id,
  frameIndexRef,
  elapsedTimeRef,
  dispatch,
  VideoUploadAction,
  meetingId,
) => {
  const stopRecordingAndUpload = React.useCallback(async () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state === "recording"
    ) {
      clearInterval(timerRef.current);

      mediaRecorderRef.current.stop();
      setIsRecording(false);
      setIsUploading(true);

      return new Promise((resolve) => {
        mediaRecorderRef.current.onstop = async () => {
          const videoBlob = new Blob(chunksRef.current, {
            type: mediaRecorderRef.current.mimeType,
          });
          chunksRef.current = [];

          try {
            const details = loan_details();
            const requestId = video_pdn_id() ? String(video_pdn_id()) : null;
            const userId = req_user_id();
            const loanID = details?.loan_id ? String(details?.loan_id) : null;
            const userTypeLabel =
              details?.user_type?.name ||
              details?.user_type_label ||
              "Applicant";
            const version = details?.version ? Number(details.version) + 1 : 1;

            const prefix = `${loanID}/${userTypeLabel}`;
            const filePrefix = prefix.replace(/\//g, "_");
            // _${meetingId}
            const fileName = `${filePrefix}_version_${version}.mp4`;
            // /${meetingId}
            //const path = `Test/${prefix}/version_${version}`;
            const path = `production/${prefix}/version_${version}`;
            const videoUrl = `${path}/${fileName}`;

            // f2f_cm_video
            // const f2f_file_name = `${loanID}_CM_version_${version}.mp4`;
            // const f2f_path = `Test/${prefix}/version_${version}`;
            // const f2f_video_url = `${f2f_path}/${f2f_file_name}`;

            // Creating FormData - Aligned EXACTLY with VideoRecorder.jsx
            const formData = new FormData();

            // 1. Video File (Key: live_streaming_video_file, Name: video_{index}.mp4)
            formData.append(
              "live_streaming_video_file",
              videoBlob,
              `video_${frameIndexRef.current}.mp4`,
            );

            // 2. Metadata
            formData.append("loan_id", loanID);
            // user_type is the ID as shown in screenshot
            formData.append(
              "user_type",
              details?.user_type?.user_type_id?.toString() || "",
            );
            formData.append("user_type_label", userTypeLabel);
            formData.append("is_edit", details?.is_edit ?? 0);
            formData.append("req_user_id", Number(userId));
            formData.append("is_online", 2);
            formData.append("meeting_id", meetingId);
            formData.append("request_id", requestId);
            formData.append("recording_duration", elapsedTimeRef.current);
            formData.append("video_url", videoUrl);
            formData.append("video_name", fileName);
            formData.append("processed_frame_path", path);
            // formData.append("f2f_cm_video", f2f_video_url);
            // formData.append("cm_video_name", f2f_file_name);
            // formData.append("cm_video_url", f2f_video_url);
            // formData.append(
            //   "cm_video_file",
            //   videoBlob,
            //   `video_${frameIndexRef.current}.mp4`,
            // );

            // // Debug: Log form data contents
            // console.log("=== Applicant Contents ===");
            // for (let pair of formData.entries()) {
            //   if (pair[1] instanceof Blob) {
            //     console.log(
            //       `${pair[0]}: [Blob] ${pair[1].type} - ${pair[1].size} bytes`,
            //     );
            //   } else {
            //     console.log(`${pair[0]}: ${pair[1]}`);
            //   }
            // }
            // console.log("========================");

            // Send via Redux action
            dispatch(VideoUploadAction(formData));
            resolve();
          } catch (error) {
            console.error("Error preparing upload:", error);
            setIsUploading(false);
            resolve();
          }
        };
      });
    }
    return Promise.resolve();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, elapsedTimeRef, meetingId]);
  return { stopRecordingAndUpload };
};
